import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import { getYamlImage } from "../lib/utils"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `useStaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `useStaticQuery`: https://www.gatsbyjs.org/docs/use-static-query/
 */

const Image = ({ file, alt, width, height, objectfit }) => {
  // console.log(file)

  const data = useStaticQuery(graphql`
    query {
      allImageSharp {
        edges {
          node {
            id
            original {
              src
              height
              width
            }
            gatsbyImageData(placeholder: BLURRED)
          }
        }
      }
    }
  `)

  // console.log("Files", data)
  const imageFile = getYamlImage(data, file)
  // console.log("getYamlImage", file, imageFile)
  // const image = getImage(data)

  if (objectfit === undefined) {
    return (
      <GatsbyImage
        width={width}
        height={height}
        image={imageFile.gatsbyImageData}
        alt={alt === undefined ? "Image" : alt}
      />
    )
  } else {
    return (
      <GatsbyImage
        width={width}
        height={height}
        image={imageFile.gatsbyImageData}
        objectFit={objectfit}
        objectPosition="center"
        alt={alt === undefined ? "Image" : alt}
      />
    )
  }
}

export default Image
